export const HomeTranslations = {
    en: {
        home: {
            getCertificate: 'Get Part Plan/Zone Certificate',
            description: 'Access and manage your zoning certificates through our secure online portal',
            applicantLogin: 'Applicant Login',
            applicantRegister: 'Applicant Registration',
            faqTitle: 'Frequently Asked Questions',
            faqSubtitle: 'Find answers to common questions about our services',
            faq1: {
                question: 'How do I apply for a Zone Certificate?',
                stepsTitle: 'To apply for a Zone Certificate, follow these steps:',
                step1: 'Register as an applicant on our portal',
                step2: 'Login to your account',
                step3: 'Fill out the required application form',
                step4: 'Upload necessary documents',
                step5: 'Submit your application'
            },
            faq2: {
                question: 'What documents are required for registration?',
                documentsTitle: 'Required documents include:',
                document1: '7/12 Extract'
            },
            faq3: {
                question: 'How long does the certification process take?',
                answer: 'The typical processing time is 7-10 working days after submission of all required documents. Complex cases may take longer.'
            },
            faq4: {
                question: 'What is the validity period of the certificate?',
                answer: 'The Zone Certificate is valid for a period of 1 year from the date of issuance. After expiry, you will need to apply for renewal.'
            },


            // questions created by departments
            faq5: {
                question: 'What is a Part Plan?',
                answer: 'A Part Plan is an extract of a specific land portion from the Development Plan or regional Plan showing boundaries and survey details as well as reservation proposals on such lands.'
            },
            faq6: {
                question: 'What is a Zone Certificate?',
                answer: 'A Zone Certificate is a document which certifies the zoning classification (e.g., residential, commercial, agricultural) of a particular land bearing survey/gat number as per sanctioned development plan / regional plan.'
            },
            faq7: {
                question: 'For what purpose is the Part Plan and the Zone Certificate required?',
                answer: 'These documents are essential for property transactions, land development proposals, construction permissions, NA (Non-Agricultural) conversions, Layout permission and valuation of land.'
            },
            faq8: {
                question: 'What documents are required to apply for getting Part Plan and Zone Certificate?',
                stepsTitle: 'Following documents are needed for getting Part Plan and Zone Certificate:',
                step1: 'Copy of 7/12 Extract or Property Card ',
                step2: 'Measurement Sheet of Land '

            },
            faq9: {
                question: 'How can an applicant apply for a Part Plan and Zone Certificate in Maharashtra?',
                answer1: 'An applicant can apply for a Part Plan and Zone Certificate to respective Town Planning Branch Office, if her land is situated in regional plan area online via Maharashtra Town Planning and Valuation Department part plan and zone certificate portal.',
                answer2: 'An applicant can apply for a Part Plan and Zone Certificate to respective Municipal Corporation / Municipal council / Nagarpanchayats (for urban areas) if her land is situated in Development Plan area.',
                answer3: 'Offline applications are made by visiting the respective Town Planning Office or Municipal Corporation / Municipal council / Nagarpanchayats.'
            },
            faq10: {
                question: 'What is the step-by-step process to get a Part Plan and Zone Certificate?',
                step1: 'Submit the application online with https://rpsangali.vishvaconnect.site this portal.',
                step2: 'Pay the prescribed fees.',
                step3: 'Document verification and processing is carried out by concerned town planning branch office.',
                step4: 'Issuance of the Part Plan and Zone Certificate - Applicant will get the part plan or zone certificate in their login online.',
            },

            faq11: {
                question: 'How much time does it take to receive the Part Plan?',
                answer: 'Generally, it takes maximum 3 working days for getting Part Plan, depending on the completeness of the documents.'
            },
            faq12: {
                question: 'How much time does it take to receive the Zone Certificate?',
                answer: 'Generally, it takes maximum 7 working days for getting Zone certificate, depending on the completeness of the documents.'
            },
            faq13: {
                question: 'What is the fee for the Part Plan and Zone Certificate?',
                answer: 'Rs. 250/- per Part Plan/ Zone Certificate for each survey number.'
            },
            faq14: {
                question: 'Can I track the status of my application?',
                answer: 'Yes. If applied online, you can track the application status through the respective portal using your application number or login credentials.'
            },

            faq15: {
                question: 'Are there any important instructions for applicants?',
                step1: 'Ensure that all documents are clear and legible',
                step2: 'Mention the correct and full survey number or CTS number',
                step3: 'Double-check the land location and boundaries before submission',
                step4: 'Keep copies of your application and receipts',
                step5: 'Follow up with the authority in case of delays',
            },
            faq16: {
                question: 'Who issues the Part Plan and Zone Certificate?',
                stepsTitle: 'Part Plan and Zone Certificate are typically issued by: ',
                step1: 'Town Planning Department Branch office (for rural areas / Regional Plan areas)',
                step2: 'Municipal Corporation or Council (depending on the jurisdiction) for Development Plan Areas (Urban Area)'

            },


            faq20: {
                question: 'What is a Part Plan?',
                answer: 'A Part Plan is an extract of a specific land portion from the Development Plan or Regional Plan showing boundaries of particular survey number details, Development Plan/ Regional Plan proposal if any, reservation proposals, or land use zone on such lands.'
            },
            
            faq21: {
                question: 'What is a Zone Certificate?',
                answer: 'A Zone Certificate is a document which certifies the zoning classification (e.g., residential, commercial, agricultural) and Development Plan/ Regional Plan proposal, if any, of a particular land bearing survey/Gat Number as per sanctioned Development Plan / Regional Plan.'
            },
            
            faq22: {
                question: 'For what purpose is the Part Plan and the Zone Certificate required?',
                answer: 'These documents are required for property transactions, land development proposals, construction permissions, NA (Non-Agricultural) conversions, layout permission, and valuation of particular land.'
            },
            
            faq23: {
                question: 'What documents are required while applying for Part Plan and Zone Certificate?',
                step1: 'Copy of 7/12 Extract or Property Card',
                step2: 'Measurement Plan of Land from TILR for Zone Certificate only',
                note: 'Some local bodies may ask for additional documents depending on the area.'
            },
            
            faq24: {
                question: 'How can an applicant apply for a Part Plan and Zone Certificate in Maharashtra?',
                step1: 'Apply online via Maharashtra Town Planning and Valuation Department part plan and zone certificate portal for Regional Plan areas.',
                step2: 'Apply to the respective Municipal Corporation / Municipal Council / Nagarpanchayat for Development Plan areas.',
                step3: 'Offline applications can be made by visiting the respective Town Planning Office or Municipal body as per jurisdiction.'
            },
            
            faq25: {
                question: 'What is the step-by-step process to get a Part Plan and Zone Certificate?',
                step1: 'Submit the application online through the portal https://rppartplan.maharashtra.gov.in',
                step2: 'Pay the prescribed fees.',
                step3: 'Document verification and processing by concerned Town Planning office/Planning Authority.',
                step4: 'Issuance of the Part Plan and Zone Certificate – available in applicant\'s login online.'
            },
            
            faq26: {
                question: 'How much time does it take to receive the Part Plan and Zone Certificate?',
                answer: 'As per Right to Services, the time limit for issuance of a Part Plan is 3 working days and for a Zone Certificate is 7 working days.'
            },
            
            faq27: {
                question: 'What is the fee for the Part Plan and Zone Certificate?',
                // step1: 'Online service: Rs. 250/- per each Survey/Gat number.',
                step1: 'service: Rs. 700/- for Part Plan and Rs. 300/- for Zone Certificate per Survey/Gat number.',
                note: 'Charges are as per government notification/circular and may change from time to time.'
            },
            
            faq28: {
                question: 'Can applicant track the status of application?',
                answer: 'Yes. If applied online, you can track the application status through the portal using the application number after login.'
            },
            
            faq29: {
                question: 'Are there any important instructions for applicants?',
                step1: 'Ensure that all documents are clear and legible',
                step2: 'Mention the correct and survey number or CTS number',
                step3: 'Double-check the land location and survey/ gat number before submission',
                step4: 'Keep copies of your application and receipts',
                step5: 'Follow up with the Authority in case of delays'
            },
            
            faq30: {
                question: 'Who issues the Part Plan and Zone Certificate?',
                stepsTitle: 'Part Plan and Zone Certificate are typically issued by:',
                step1: 'Town Planning Department, district level Branch office (for rural areas / Regional Plan areas)',
                step2: 'Municipal Corporation or Municipal Council/ Nagarpanchayat (depending on the jurisdiction) for Development Plan Areas (Urban Area)'
            },

            

        },


    },
    mr: {
        home: {
            getCertificate: 'भाग नकाशा/झोन दाखला प्राप्त करा',
            description: 'आमच्या सुलभ व सुरक्षित प्रणालीद्वारे आपला भाग नाकाशा व झोन दाखला मिळवा.',
            applicantLogin: 'अर्जदार लॉगिन',
            applicantRegister: 'अर्जदार नोंदणी',
            faqTitle: 'सामान्य प्रश्न',
            faqSubtitle: 'आमच्या सेवांबाबत विचारले जाणारे महत्त्वाचे प्रश्न आणि त्यांची उत्तरे',
            faq1: {
                question: 'झोन प्रमाणपत्रासाठी मी अर्ज कसा करू?',
                stepsTitle: 'झोन प्रमाणपत्रासाठी अर्ज करण्यासाठी या चरणांचे अनुसरण करा:',
                step1: 'आमच्या पोर्टलवर अर्जदार म्हणून नोंदणी करा',
                step2: 'तुमच्या खात्यात लॉगिन करा',
                step3: 'आवश्यक अर्ज फॉर्म भरा',
                step4: 'आवश्यक कागदपत्रे अपलोड करा',
                step5: 'तुमचा अर्ज सबमिट करा'
            },
            faq2: {
                question: 'नोंदणीसाठी कोणती कागदपत्रे आवश्यक आहेत?',
                documentsTitle: 'आवश्यक कागदपत्रांमध्ये हे समाविष्ट आहे:',
                document1: 'मालमत्तेचे कागदपत्रे (7/12 उतारा)'
            },
            faq3: {
                question: 'प्रमाणपत्र प्रक्रियेस किती वेळ लागतो?',
                answer: 'सर्व आवश्यक कागदपत्रे सबमिट केल्यानंतर सामान्य प्रक्रिया वेळ 7-10 कामकाजाचे दिवस असते. गुंतागुंतीच्या केससाठी अधिक वेळ लागू शकतो.'
            },
            faq4: {
                question: 'प्रमाणपत्राचा वैधता कालावधी किती आहे?',
                answer: 'झोन प्रमाणपत्र जारी केल्याच्या तारखेपासून 1 वर्षाच्या कालावधीसाठी वैध आहे. कालबाह्य झाल्यानंतर, तुम्हाला नूतनीकरणासाठी अर्ज करावा लागेल.'
            },


            // विभागांनी तयार केलेले प्रश्न
            faq5: {
                question: 'भाग नकाशा म्हणजे काय?',
                answer: 'भाग नकाशा म्हणजे विकास आराखडा किंवा प्रादेशिक आराखड्यातील विशिष्ट भूभागाचा उतारा असतो, ज्यामध्ये त्या भूभागाच्या सीमा, सर्वेक्षण तपशील तसेच आरक्षण प्रस्तावांचा समावेश असतो.'
            },
            faq6: {
                question: 'झोन दाखला म्हणजे काय?',
                answer: 'झोन दाखला हा असा दस्तऐवज आहे जो संबंधित सर्वे / गट क्रमांकाच्या भूखंडाचे विकास आराखडा / प्रादेशिक आराखड्यानुसार झोन वर्गीकरण (उदा. निवासी, व्यावसायिक, शेती) प्रमाणित करतो.'
            },
            faq7: {
                question: 'भाग नकाशा आणि झोन दाखला कोणत्या उद्देशासाठी आवश्यक असतात?',
                answer: 'हे दस्तऐवज मालमत्ता व्यवहार, भूविकास प्रस्ताव, बांधकाम परवानग्या, एन.ए. (नॉन-अग्रीकल्चरल) रूपांतरण, लेआउट परवानगी आणि भू-मूल्यांकनासाठी आवश्यक असतात.'
            },
            faq8: {
                question: 'भाग नकाशा आणि झोन दाखला मिळवण्यासाठी कोणते दस्तऐवज आवश्यक असतात?',
                stepsTitle: 'भाग नकाशा आणि झोन दाखला मिळवण्यासाठी खालील दस्तऐवज आवश्यक आहेत:',
                step1: '७/१२ उताऱ्याची किंवा प्रॉपर्टी कार्डची प्रत',
                step2: 'भूखंडाचे मोजणी पत्र'
            },
            faq9: {
                question: 'महाराष्ट्रात भाग नकाशा आणि झोन दाखला मिळवण्यासाठी अर्ज कसा करावा?',
                answer1: 'जर भूखंड प्रादेशिक आराखडा क्षेत्रात असेल, तर संबंधित नगर रचना शाखा कार्यालयाकडे महाराष्ट्र नगर रचना आणि मूल्यनिर्धारण विभागाच्या पोर्टलवरून ऑनलाइन अर्ज करता येतो.',
                answer2: 'जर भूखंड विकास आराखडा क्षेत्रात असेल (शहरी भाग), तर संबंधित महानगरपालिका / नगरपालिका / नगरपंचायत यांच्याकडे अर्ज करता येतो.',
                answer3: 'ऑफलाइन अर्ज संबंधित नगर रचना कार्यालय किंवा महानगरपालिका / नगरपालिका / नगरपंचायतला भेट देऊन करता येतो.'
            },
            faq10: {
                question: 'भाग नकाशा आणि झोन दाखला मिळवण्याची टप्प्याटप्प्याने प्रक्रिया काय आहे?',
                step1: 'https://rpsangali.vishvaconnect.site या पोर्टलवर ऑनलाइन अर्ज सादर करा.',
                step2: 'निर्धारित शुल्क भरा.',
                step3: 'संबंधित नगर रचना शाखा कार्यालयाकडून दस्तऐवजांची पडताळणी व प्रक्रिया केली जाते.',
                step4: 'भाग नकाशा आणि झोन दाखला जारी - अर्जदारास लॉगिनमध्ये हे ऑनलाइन स्वरूपात मिळेल.'
            },
            faq11: {
                question: 'भाग नकाशा मिळण्यासाठी किती वेळ लागतो?',
                answer: 'सर्वसाधारणपणे, दस्तऐवज पूर्ण असल्यास भाग नकाशा मिळण्यासाठी जास्तीत जास्त ३ कामकाजाचे दिवस लागतात.'
            },
            faq12: {
                question: 'झोन दाखला मिळण्यासाठी किती वेळ लागतो?',
                answer: 'सर्वसाधारणपणे, दस्तऐवज पूर्ण असल्यास झोन दाखला मिळण्यासाठी जास्तीत जास्त ७ कामकाजाचे दिवस लागतात.'
            },
            faq13: {
                question: 'भाग नकाशा आणि झोन दाखल्यासाठी किती शुल्क आहे?',
                answer: 'प्रत्येक सर्वे नंबरसाठी भाग नकाशा / झोन दाखल्याचे शुल्क रु. 25०/- आहे.'
            },
            faq14: {
                question: 'माझ्या अर्जाची स्थिती मी ट्रॅक करू शकतो का?',
                answer: 'होय. जर ऑनलाइन अर्ज केला असेल, तर अर्ज क्रमांक किंवा लॉगिन माहिती वापरून पोर्टलवर अर्जाची स्थिती तपासता येते.'
            },
            faq15: {
                question: 'अर्जदारांसाठी काही महत्वाच्या सूचना आहेत का?',
                step1: 'सर्व दस्तऐवज स्पष्ट व वाचनीय असावेत',
                step2: 'योग्य आणि पूर्ण सर्वे नंबर किंवा CTS नंबर नमूद करा',
                step3: 'अर्ज सादर करण्यापूर्वी भूस्थान व सीमा तपासा',
                step4: 'तुमच्या अर्जाची व पावत्यांची प्रत ठेवा',
                step5: 'उशीर झाल्यास संबंधित प्राधिकरणाशी संपर्क साधा'
            },
            faq16: {
                question: 'भाग नकाशा आणि झोन दाखला कोण जारी करतो?',
                stepsTitle: 'भाग नकाशा आणि झोन दाखला खालील विभागांकडून जारी केला जातो:',
                step1: 'नगर रचना विभागाचे शाखा कार्यालय (ग्रामीण / प्रादेशिक आराखडा क्षेत्रासाठी)',
                step2: 'महानगरपालिका / नगरपालिका / नगरपंचायत (शहरी विकास आराखडा क्षेत्रासाठी)'
            },

            faq20: {
                question: 'भाग नकाशा म्हणजे काय?',
                answer: 'भाग नकाशा हा विकास योजना किंवा प्रादेशिक योजनेतील विशिष्ट जमिनीच्या भागाचा उतारा आहे, ज्यामध्ये सीमा आणि सर्वे क्रमांक तपशील तसेच अशा जमिनींवरील आरक्षणाचे प्रस्ताव तसेच जमिन वापर/ रस्ते इ. तपशील दर्शविलेले असतात.'
            },
            
            faq21: {
                question: 'झोन प्रमाणपत्र म्हणजे काय?',
                answer: 'झोन प्रमाणपत्र हे एक दस्तऐवज आहे जे मंजूर विकास आराखडा/प्रादेशिक योजनेनुसार एखाद्या विशिष्ट भू-मापन सर्वे/गट क्रमांकाचे जमिन वापर वर्गीकरण (उदा. निवासी, व्यावसायिक, कृषी इ.) प्रमाणित करते. त्यानुसार जमिनीचा अनुज्ञेय वापर ठरविण्यात येतो.'
            },
            
            faq22: {
                question: 'भाग नकाशा आणि झोन प्रमाणपत्र कोणत्या उद्देशासाठी आवश्यक आहे?',
                answer: 'भाग नकाशा आणि झोन प्रमाणपत्र ही कागदपत्रे मालमत्तेचे व्यवहार, जमीन विकास प्रस्ताव, बांधकाम परवानगी, एनए (अकृषिक) रूपांतरण, जमिन रेखांकन (ले-आऊट) परवानगी आणि जमिनीचे मूल्यांकन यासाठी आवश्यक आहेत.'
            },
            
            faq23: {
                question: 'भाग नकाशा आणि झोन प्रमाणपत्र मिळविण्यासाठी अर्ज करण्यासाठी कोणती कागदपत्रे आवश्यक आहेत?',
                step1: '7/12 उतारा किंवा मालमत्ता पत्रकाची प्रत',
                step2: 'जमिनीचा मोजणी नकाशा (फक्त झोन प्रमाणपत्रासाठी)',
                note: 'काही स्थानिक स्वराज्य संस्था क्षेत्र व आवश्यकतेनुसार अतिरिक्त कागदपत्रे मागू शकतात.'
            },
            
            faq24: {
                question: 'भाग नकाशा आणि झोन प्रमाणपत्रासाठी अर्ज करण्याची काय पद्धत आहे?',
                step1: 'प्रादेशिक योजना क्षेत्रासाठी – महाराष्ट्र नगररचना व मूल्यनिर्धारण विभागाच्या पोर्टलवरून संबंधित नगररचना शाखेकडे ऑनलाइन अर्ज.',
                step2: 'विकास योजना क्षेत्रासाठी – संबंधित महानगरपालिका/नगरपरिषद/नगरपंचायतीकडे अर्ज.',
                step3: 'ऑफलाइन अर्ज – संबंधित कार्यालयास भेट देऊन करता येतो.'
            },
            
            faq25: {
                question: 'भाग नकाशा आणि झोन प्रमाणपत्र मिळविण्यासाठी टप्पेनिहाय प्रक्रिया काय आहे?',
                step1: 'https://rppartplan.maharashtra.gov.in या पोर्टलवर ऑनलाइन अर्ज सादर करा.',
                step2: 'विहित शुल्क भरा.',
                step3: 'संबंधित नगररचना शाखा कार्यालयाद्वारे दस्तऐवजांची पडताळणी व प्रक्रिया.',
                step4: 'प्रस्ताव मंजूर झाल्यास लॉगिनमध्ये प्रमाणपत्र उपलब्ध होईल.'
            },
            
            faq26: {
                question: 'भाग नकाशा प्राप्त करण्यासाठी किती वेळ लागतो?',
                answer: 'सेवेचा हक्क अधिनियम, 2015 नुसार – भाग नकाशा मिळविण्यास 3 कार्यदिवस व झोन प्रमाणपत्रासाठी 7 कार्यदिवस लागतात.'
            },
            
            faq27: {
                question: 'भाग नकाशा आणि झोन प्रमाणपत्रासाठी किती शुल्क आहे?',
                // step1: 'ऑनलाइन सेवा: रु. 250/- प्रति भुमापन क्रमांक/ प्रमाणपत्र',
                step1: 'सेवा: भाग नकाशा – रु. 700/- आणि झोन प्रमाणपत्र – रु. 300/-',
                note: 'शुल्क शासन वेळोवेळी निश्चित करेल.'
            },
            
            faq28: {
                question: 'अर्जाची सद्यस्थिती कशी तपासता येईल?',
                answer: 'होय. अर्जदार लॉगिन करून अर्ज क्रमांक वापरून पोर्टलवर अर्जाची सद्यस्थिती पाहू शकतात.'
            },
            
            faq29: {
                question: 'अर्जदारांसाठी काही महत्त्वाच्या सूचना आहेत का?',
                step1: 'सर्व कागदपत्रे स्पष्ट आणि वाचनीय असावीत.',
                step2: 'योग्य आणि पूर्ण सर्वे/गट क्रमांक किंवा CTS क्रमांक नमूद करावा.',
                step3: 'जमिनीचे स्थान आणि सीमा योग्य असल्याची खात्री करावी.',
                step4: 'अर्जाची आणि पावतीची प्रत जतन करून ठेवावी.',
                step5: 'विलंब झाल्यास प्राधिकरणाशी पाठपुरावा करावा.'
            },
            
            faq30: {
                question: 'भाग नकाशा आणि झोन प्रमाणपत्र कोण जारी करते?',
                stepsTitle: 'भाग नकाशा आणि झोन प्रमाणपत्र खालील प्राधिकरणांद्वारे दिले जातात:',
                step1: 'नगररचना आणि मूल्यनिर्धारण विभाग, शाखा कार्यालय – ग्रामीण/प्रादेशिक योजना क्षेत्रासाठी',
                step2: 'महानगरपालिका / नगरपरिषद / नगरपंचायत – शहरी/विकास योजना क्षेत्रासाठी'
            },
            




        },

    }
};
